// extracted by mini-css-extract-plugin
module.exports = {"DotNavigation":"DotNavigation_DotNavigation__3_t4A","dot":"DotNavigation_dot__1HwoA","dotActive":"DotNavigation_dotActive__3R91w DotNavigation_dot__1HwoA"};